module.exports = __webpack_public_path__ + "static/media/18.5ee6b2c9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/black/18.jpg
// module id = 279
// module chunks = 0